enum EstadoAseguradora {
  Pendiente = "PENDIENTE",
  Aprobada = "APROBADO",
  Declinada = "DECLINADA",
}

export default EstadoAseguradora;
